module.exports = __webpack_public_path__ + "img/flyer-batten.3a268f7d.jpg";